<h2 data-testid="SUBSYS5_ANOMALYTABLE_TITLE_TXT" class="text-uppercase mb-0">
	{{ labels().ANOMALY_TABLE_COMPONENT_TITLE }}
</h2>

<div class="mt-5">
	<tsp-history-filters [isDiary]="false" [isReadonly]="isReadonly()" [filters]="filters()"
		(filtersChange)="updateList($event)" />
</div>

@if (anomalies().length) {

<div class="mt-4">
	<tsp-history-table [isDiary]="false" [isReadonly]="isReadonly()" [(items)]="anomalies" [sortOrder]="sortOrder()"
		(sortOrderChange)="sort($event)" />
</div>

@if (!isReadonly()) {
<div class="row mt-4">
	<div class="col d-flex justify-content-end">
		@if(isUnreadBtnVisible()) {
		<button data-testid="SUBSYS5_ANOMALYTABLE_UNREAD_BTN" type="button" class="btn btn-primary"
			[disabled]="isReadBtnDisabled()" (click)="unread()">
			{{ labels().ANOMALY_TABLE_COMPONENT_UNREAD_BTN }}
		</button>
		}
		<button data-testid="SUBSYS5_ANOMALYTABLE_READ_BTN" type="button" class="btn btn-primary ms-3"
			[disabled]="isReadBtnDisabled()" (click)="read()">
			{{ labels().ANOMALY_TABLE_COMPONENT_READ_BTN }}
		</button>
	</div>
</div>
}

<div class="mt-4">
	<tsp-pagination [collectionSize]="collectionSize()" [(page)]="pageNumber" (pageChange)="updatePageNumber()"
		[(pageSize)]="pageSize" (pageSizeChange)="updatePageSize()" />
</div>

} @else {
<div data-testid="SUBSYS5_ANOMALYTABLE_EMPTY_TXT" class="mt-5">
	<h3>{{ labels().ANOMALY_TABLE_COMPONENT_TABLE_EMPTY }}</h3>
</div>
}